export const MAX_UPLOAD_FILE_SIZE_MB = 40;

export function getBase64FileSizeInBytes(dataUrl: string): number {
  const base64 = dataUrl?.split(',')[1] ?? '';
  const padding = base64.match(/=+$/)?.[0].length ?? 0;
  return Math.floor((base64.length * 3) / 4) - padding;
}

export function isBase64FileTooLarge(dataUrl: string, maxSizeMb: number = MAX_UPLOAD_FILE_SIZE_MB): boolean {
  return getBase64FileSizeInBytes(dataUrl) > maxSizeMb * 1024 * 1024;
}
